import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'
import withData from '../utils/withData'

import {
  Link
} from 'react-router-dom';

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import OpeningTimes from '../components/OpeningTimes'
import CallToAction from '../components/CallToAction'
import Happenings from '../components/Happenings'
import Rates from '../components/Rates'
import LiveGallery from '../components/LiveGallery'
import ContentBlocks from '../components/ContentBlocks'
import MiniMap from '../components/MiniMap'
import Window from '../components/Window'

import Asset from '../models/Asset'
import Entry from '../models/Entry'

require('../helpers/Array.js');



class Signup extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	


	/*

		RENDER

	*/

	render() {


		return (
			<FadeIn>
			<div className={"Template  Template--default Template--signup"}>

			{/* Template-body */}
					<div className="Template-body">



						<div className="Template-sections">

					{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--container">
								<div className="Template-heading">
									<Content html="<h1>Speak up!</h1><p>Tell us who you are and get free stuff</p>" />
								</div>
								<div className="Template-content">
									<Newsletter />
								</div>
							</div>
							{/* / Template-section */}

						</div>

					</div>


			</div>
			</FadeIn>
		);

	}
}

export default withData(Signup);



// WEBPACK FOOTER //
// ./src/js/templates/Signup.jsx